import { IsString, IsDefined } from 'class-validator';
import { RgbaDto } from './RgbaDto';
import { GradientDto } from './GradientDto';
import { IsColorOrReference } from './validators/IsColorOrReference';

export class LinkStyleDto {
  @IsDefined()
  @IsColorOrReference()
  fontColor!: RgbaDto | GradientDto | string;

  @IsColorOrReference()
  backgroundColor!: RgbaDto | GradientDto | string | null;

  @IsDefined()
  @IsString()
  fontWeight!: string;

  @IsDefined()
  @IsString()
  decoration!: string;
}
